export const SET_SHORTCUT_DISABLE_STATUS = 'SET_SHORTCUT_DISABLE_STATUS';
export const SET_IS_EDITOR_OPEN = 'SET_IS_EDITOR_OPEN';
export const SET_SHORTCUT_MODAL_OPEN_STATUS = 'SET_SHORTCUT_MODAL_OPEN_STATUS';

export const SHORTCUT_MODAL_OPEN_PAGE = {
  PROFILE: 'profile',
  INBOX: 'inbox',
  RELATIONSHIP_BOARD: 'relationship_board',
};
